export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actionsTemplates: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModalTemplates'
            },
            {
                btn_text: '<i class="fas fa-file-excel"></i> Új Excel feltöltése',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class",
                event_payload: 'newXlsx'
            },
            {
                btn_text: '<i class="fas fa-file-download"></i> Minta Excel letöltése',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class",
                event_payload: 'downloadTemplate'
            },
            {
                btn_text: '<i class="fas fa-info"></i> WIKI',
                event_name: "customClick",
                class: "btn btn-info",
                event_payload: 'openWiki'
            },
            {
                btn_text: '<i class="fas fa-exchange-alt"></i> Váltás beutalókra',
                event_name: "customClick",
                class: "btn btn-dark-teal",
                event_payload: 'switchDataTable'
            },
        ],
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új beutaló',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-exchange-alt"></i> Váltás beutaló sablonokra',
                event_name: "customClick",
                class: "btn btn-dark-teal",
                event_payload: 'switchDataTable'
            },
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        xlsxFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning mx-1",
                event_payload: 'backToGridFromXlsxForm'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary mx-1",
                event_payload: 'resetXlsxForm'
            },
            {
                btn_text: '<i class="fas fa-check"></i> Adatellenőrzés',
                event_name: "customClick",
                class: "btn btn-info mx-1",
                event_payload: 'validateXls',
            },
        ],
        rowActionsReadOnly: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'seeDetails'
            },
            {
                btn_text: '<i class="fas fa-file-download"></i>',
                title: 'Letöltés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'downloadDocument',
                additionalButtonVisible: "isShowEditOccuHeaReferral3"
            }
        ],
        rowActionsDoctor: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'seeDetails'
            },
            {
                btn_text: '<i class="fas fa-file-download"></i>',
                title: 'Letöltés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'downloadDocument',
                additionalButtonVisible: "isShowEditOccuHeaReferral3"
            },
            {
                btn_text: '<i class="fas fa-file-import"></i>',
                title: 'Felhasználás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'setToUsed',
                additionalButtonVisible: "isShowEditOccuHeaReferral"
            }
        ],
        rowActionsTemplates: [
            {
                btn_text: '<i class="fas fa-print"></i>',
                title: 'Nyomtatás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'printRow',
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow',
                additionalButtonVisible: "isShowEditOccuHeaReferral"
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow',
                additionalButtonVisible: "isShowEditOccuHeaReferral"
            },
            {
                btn_text: '<i class="fas fa-print"></i>',
                title: 'Nyomtatás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'printRow',
            },
            {
                btn_text: '<i class="fas fa-file-download"></i>',
                title: 'Letöltés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'downloadDocument',
                additionalButtonVisible: "isShowEditOccuHeaReferral2"
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow',
                additionalButtonVisible: "isShowEditOccuHeaReferral"
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "hierarchyName",
                label: "Munkahely",
                visibility: true
            },
            {
                name: "employeeId",
                label: "Törzsszám",
                visibility: true
            },
            {
                name: "patientName",
                label: "Név",
                visibility: true
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ",
                visibility: true
            },
            {
                name: "referralTypeName",
                label: "Vizsgálat oka",
                visibility: true
            },
            {
                name: "used",
                label: "Felhasznált",
                visibility: true,
                slot_name: "checkFormat1"
            },
            {
                name: "createdBy",
                label: "Létrehozó",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Létrehozás ideje",
                slot_name: "birthdate_format",
                visibility: true,
                sort: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        headerFieldsTemplates: [
            {
                name: "hierarchyName",
                label: "Munkahely",
                visibility: true
            },
            {
                name: "employeeId",
                label: "Törzsszám",
                visibility: true
            },
            {
                name: "patientName",
                label: "Név",
                visibility: true
            },
            {
                name: "socialInsuranceNumber",
                label: "TAJ",
                visibility: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        patientDetailsHeaderFields: [
            {
                name: "hierarchyName",
                label: "Munkahely",
                visibility: true
            },
            {
                name: "referralTypeName",
                label: "Vizsgálat oka",
                visibility: true
            },
            {
                name: "used",
                label: "Felhasznált?",
                visibility: true,
                slot_name: "checkFormat1"
            },
            {
                name: "createdBy",
                label: "Létrehozó",
                visibility: true
            },
            {
                name: "createdOn",
                label: "Létrehozva",
                slot_name: "birthdate_format",
                visibility: true,
                sort: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        xlsxFormFields: [
            {
                name: "fileData",
                label: "Feltöltés...",
                formType: "xlsFileInput",
                fileSize: "1024",
                formRequired: true,
                formSize: 4,
                visibility: false,
                formVisible: true,
            },
            {
                name: "email",
                label: "E-mail",
                enableCopy: true,
                formRequired: true,
                formType: "email",
                formSize: 4,
                formVisible: true,
                visibility: false
            },
        ],
    }
}
